// src/environments/environment.ts
const environments = {
  development: {
    REACT_APP_BACKEND_API_BASE_URL: "https://api.sitepilot.online/onboarding",
    REACT_APP_CHAT_API: "https://api.sitepilot.online/rag/chat/",
    REACT_APP_DOC_URL: "https://api.sitepilot.online/rag/document/get",
    REACT_APP_GOOGLE_CLIENT_ID:
      "107189977981-u6ph9pkdjnate5ck8iusid73n8v24crg.apps.googleusercontent.com",
    REACT_APP_USE_MOCK_DATA: true,
  },
  production: {
    REACT_APP_BACKEND_API_BASE_URL: "https://api.sitepilot.online/onboarding",
    REACT_APP_CHAT_API: "https://api.sitepilot.online/rag/chat/",
    REACT_APP_DOC_URL: "https://api.sitepilot.online/rag/document/get",
    REACT_APP_GOOGLE_CLIENT_ID:
      "107189977981-u6ph9pkdjnate5ck8iusid73n8v24crg.apps.googleusercontent.com",
    REACT_APP_USE_MOCK_DATA: false,
  },
};

const currentEnv = process.env.REACT_APP_ENV || "development";
const environment = environments[currentEnv];
console.log("environment----->", environment);

export default environment;
